import React from 'react';
import _ from 'lodash';

import {
  BaseWidget,
  SkuSwapModal
} from 'modules';
import {
  modalUtil,
  Table
} from 'iron-forge-react-modules';
import {
  IconButton,
  TextField
} from '@mui/material';
import {
  Search,
  SwapHoriz
} from '@mui/icons-material';

import * as dataService from './dataService';
import * as types from './types';



const TableComponent = Table.genTableComponent<types.IColumnId>();



export const FC: React.FC = () => {
  const {
    queryTuple,
    pageInfo,
    fnQueryPage,
    fnQuery
  } = dataService.useQuery();
  const {
    modalType2TargetId,
    setModalIsOpen
  } = modalUtil.useModalTrackers(['skuSwap']);



  function handleCloseSkuSwapModal() {
    setModalIsOpen('skuSwap', false);
    if (queryTuple.refetch) {
      queryTuple.refetch();
    }
  }

  const handleClickRow = React.useCallback(
    (orderId: string) => {
      setModalIsOpen('skuSwap', orderId);
    },
    [setModalIsOpen]
  );

  const rows = React.useMemo(
    () => _.map(queryTuple.data.orders, (order): types.IRow => ({
      id: order.id,
      columnId2Value: {
        orderNumber: {
          type: 'string',
          label: order.orderNumber
        },
        orderDate: {
          type: 'string',
          label: order.orderDate.toFormat('yyyy-MM-dd @ hh:mm a')
        },
        actions: {
          type: 'component',
          sortableValue: '',
          label: (
            <IconButton
              size="small"
              onClick={_.partial(handleClickRow, order.id)}>
              <SwapHoriz />
            </IconButton>
          )
        }
      }
    })),
    [
      handleClickRow,
      queryTuple.data.orders
    ]
  );



  const handleChangeSearch = _.debounce((search: string) => {
    fnQuery({
      filter: {
        omniFreeText: search
      }
    });
  }, 500);



  return (
    <>
      <BaseWidget.FC
        title="Possible SKU Mismatches"
        elAction={(
          <TextField
            label="Search"
            placeholder="Search"
            InputProps={{
              startAdornment: <Search />
            }}
            onChange={ev => handleChangeSearch(ev.target.value)} />
        )}>
        <TableComponent
          paginationOptions={Table.pageInfo2PaginationOptions(pageInfo, fnQueryPage)}
          disableSorting
          columns={[
            {
              id: 'orderNumber',
              label: "Order Number"
            },
            {
              id: 'orderDate',
              label: "Order Date"
            },
            {
              id: 'actions',
              label: ""
            }
          ]}
          rows={rows} />
      </BaseWidget.FC>

      {modalType2TargetId.skuSwap && (
        <SkuSwapModal.FC
          orderId={modalType2TargetId.skuSwap}
          onClose={handleCloseSkuSwapModal} />
      )}
    </>
  );
};
